import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../components/common/FormikControl";

  const Filter = () => {

  const initialValues = {
    clinical_status: "",
    Financial_status: "",
    type: "",
    apheresis_date: "",
    product: "",
  }

  const clinicialStatusOptions = [
    { value: 'feasible', label: 'Feasible' },
    { value: 'nonFeasible', label: 'Non Feasible' }
  ]

  const financialStatusOptions = [
    { value: 'feasible', label: 'Feasible' },
    { value: 'nonFeasible', label: 'Non Feasible' }
  ]

  const typeOptions = [
    { value: 'pms', label: 'PMS' },
    { value: 'commercial', label: 'Commercial' },
    { value: 'trial', label: 'Trial' },
  ]

  const productOptions = [
    { value: 'bcma', label: 'BCMA' },
    { value: 'carT', label: 'CAR-T' }
  ]

  const formOptions = [
    {
      label: 'Clinical Status',
      type: 'checkbox',
      name: 'clinical_status',
      options: clinicialStatusOptions
    },
    {
      label: 'Financial Status',
      type: 'checkbox',
      name: 'Financial_status',
      options: financialStatusOptions
    },
    {
      label: 'Type',
      type: 'checkbox',
      name: 'type',
      options: typeOptions
    },
    {
      label: 'Apheresis Date',
      type: 'date',
      name: 'apheresis_date',
    },
    {
      label: 'Product',
      type: 'select',
      name: 'product',
      placeholder: 'Select Product',
      options: productOptions
    }
  ]


  
  const handleSubmit = () => {}

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit
  })

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        {formOptions.map((props, key)=>(
          <Grid key={key} item xs={12}>
          <FormikControl formik={formik} {...props} />
          </Grid>
        ))}
        
        <Box sx={{ display: "flex", gap: 2, marginTop: "10px" }}>
            <LoadingButton fullWidth type="submit" variant="contained">Apply Filter</LoadingButton>
          </Box>
      </form>
    </Box>
  );
}

export default Filter;